<template>
  <div class="son">
            <div :class="count[index].data.children.length>0?'hasborder':''">
                <div class="inner">
                <!-- {{id}} -->
                <inputdata :rules='count[index].rules' :databasetype='databasetype'></inputdata>
             </div>
             <div class="icondelete">
                 <!-- 三成嵌套不用就关了 -->
                <!-- <span class="el-icon-circle-plus-outline" @click="addchild(index)"></span> -->
                <span class="el-icon-remove-outline" @click="removechild(index)" v-if="count.length>1"></span>
              </div>
            </div>
            <!-- 三成嵌套条件>0 -->
            <div v-if='count[index].data.children.length==-1'>
                <father :count='count[index].data.children' @deletechild='deletechild' :type='count[index].data.type' @changeMode='changeMode'></father>
            </div>
    </div>
</template>

<script>
import father from '@/components/children/father.vue'
import inputdata from '@/components/children/input.vue'

export default {
    name:'children',
    components:{
        father,
        inputdata
    },
    props:['count','index','id','databasetype'],
    mounted(){
        console.log(this.count);
        console.log(this.databasetype);
    },
    methods:{
        removechild(index){
            this.$emit('delete',index)
        },
        addchild(index){
            this.$emit('addchlid',index)
            console.log(this.count);
        },
        deletechild(index){
            console.log(index,this.index);
            this.$emit('deletechild',index,this.index)

        },
        changeMode(){
            this.$emit('changechildmode',this.index)
        }
    }
}
</script>

<style scoped>
.son{
    position: relative;
}
.inner{
        width: 100%;
        height: 60px;
    }
    .icondelete{
        color: brown;
        position: absolute;
        right: 0;
        top: 30px;
        /* margin-top: 10px; */
        width: 50px;
    cursor: pointer;
    }
    .icondelete:active{
        color: red;
    }
    .el-icon-circle-plus-outline{
    color: greenyellow;
    cursor: pointer;
}
.el-icon-circle-plus-outline:active{
    color: blue;
}
.hasborder{
    border-bottom:1px solid #ccc
}
</style>


// WEBPACK FOOTER //
// src/components/children/children.vue